import styled, { css }  from 'styled-components'
import { Link as LinkRouter } from '@reach/router'

export const Nav = styled.nav`
    justify-content: space-between;
    z-index: 10;
    align-items: center;

    @media screen and (max-width: 1500px) {

    }

    @media screen and (max-width: 768px) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: #fff;
        text-align: right;
        position: fixed;
        top: 0;
        left: 0;
        transition: all 0.9s ease-in-out;
        height: 100vh;
        width: 100%;
        padding: 5rem 2rem 2rem 2rem;
        opacity: ${({ open }) => open ? '1' : '0'};
        visibility: ${({ open }) => open ? 'visible' : 'hidden'};
        transform: ${({ open }) => open ? 'translateX(0%)' : 'translateX(-100%)'};
    }
`

export const Link = styled(LinkRouter)`
    color: #C24728;
    display: inline-block;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;
    font-weight: bold;
    font-size: 16px;
    &:after {
        content: '';
        border-image: linear-gradient(to right,#c247283b 0%,#C24728 100%);
        border-bottom: solid 3px transparent;
        border-image-slice: 1; 
        transform: scaleX(0);  
        transition: transform 250ms ease-in-out;
        display: block;
        padding: 2px;
    }

    &:hover {
        color: #C24728;
        &::after {
            transform: scaleX(1);
        }
    }

    @media screen and (max-width: 768px) {
        display: grid;
        text-align: center;
        border: 0;
        border-bottom: 1px solid #C24728;
        width: 100%;

        &:after {
            content: '';
            border-bottom: 0px #C24728;  
            transform: scaleX(0);  
            transition: transform 250ms ease-in-out;
            display: none;
        }

        &:hover {
            background-color: #C24728;
            color: #fff;
            position: relative;
            z-index: 2;
            transition: 0.8s;
            border-bottom: 0px #C24728;
        }
    }
`